module.exports = __webpack_public_path__ + "static/media/Saleschannel_Logotype_RGB_Black_2.50990f59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Saleschannel_Logotype_RGB_Black_2.svg
// module id = 1091
// module chunks = 0